import EstrelaIcon from "@/assets/icons/gantt-estrela.svg?react";

import styles from "../gantt.module.scss";
import type { GanttMarkerViewProps } from "../types-gantt";

/** Marco na área temporal da linha: a linha tracejada do limite ou a estrela do início. */
export function GanttMarkerView({ marker }: GanttMarkerViewProps) {
  return (
    <span
      className={styles.marker}
      style={marker.style}
      data-kind={marker.kind}
      data-testid={marker.testId}
      aria-hidden
    >
      {marker.withStar ? <EstrelaIcon /> : null}
    </span>
  );
}
GanttMarkerView.displayName = "Gantt.RowMarker";
